import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "forward-arrow--sprite",
  "use": "forward-arrow--sprite-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol viewBox=\"0 0 12 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"forward-arrow--sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.960999 19.0662C1.48313 19.5834 2.3244 19.5834 2.84653 19.0662L12 10L2.84653 0.933778C2.3244 0.416625 1.48313 0.416627 0.961 0.93378C0.43175 1.45798 0.43175 2.31325 0.961 2.83745L8.19247 10L0.960999 17.1625C0.431749 17.6867 0.431749 18.542 0.960999 19.0662Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol